export default class ArticleOnPageNav extends HTMLElement {

    connectedCallback() {

        console.log("ArticleOnPageNav connected");

        this.items = this.querySelectorAll(".nav-link");
        this.headings = document.querySelectorAll(".anchor-heading");
        this.navAnchor = this.querySelector(".anchor-links-wrapper");
        this.navAnchor.scrollLeft = 0;
        this.firstHeadingId = "";
        this.scrollDebounce = true;
        this.scrollisjumping = false;
        this.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const startanchor = decodeURI(this.getAnchor());

        console.log(this.items.length + " items");
        console.log(this.headings.length + " headings");
        console.log(this.navAnchor.length + " navAnchor");

        if (this.width < 768) {
            this.style.minHeight = (document.body.scrollHeight - (this.getBoundingClientRect().top + document.documentElement.scrollTop)) + 'px';
            this.navAnchor.style.top = document.querySelector(".global-header").clientHeight + "px";
        }

        this.items.forEach(item => {
            let href = item.href;
            let path = href.substring(href.lastIndexOf('/') + 1);
            let anchor = decodeURI(path.replace('#', ''));
            if (anchor == startanchor) {

                item.classList.add('active');
                window.scrollTo(0, document.getElementById(startanchor).getBoundingClientRect().top + window.scrollY);
                if (this.width < 768) this.hScrollTo(item);
                
            } 


        })
        setTimeout(function () { this.scrollDebounce = true; }, 2000);


        document.addEventListener("scroll", () => {
            console.log("ArticleOnPageNav::scroll")
            if (this.scrollDebounce && !this.scrollisjumping) {
                this.scrollDebounce = false;
                let _this = this;
                // Get id of the first heading in the viewport and "lock it in".
                for (var k = 0; k < this.headings.length; k++) {
                    if (_this.isElementInViewport(_this.headings[k])) {
                        _this.firstHeadingId = _this.headings[k].id;
                        break;
                    }
                }
                this.items.forEach(item => {
                    let href = item.href;
                    let path = href.substring(href.lastIndexOf('/') + 1);
                    let anchor = decodeURI(path.replace('#', ''));
                    if (anchor === this.firstHeadingId) {
                        item.classList.add('active');
                        if (_this.width < 768) {
                            _this.hScrollTo(item);
                        } 
                    } else {
                        item.classList.remove('active');
                    }
                    
                    
                })
                setTimeout(function () { _this.scrollDebounce = true; }, 150);
            }
        })
        this.items.forEach(item => {

            item.addEventListener("click", (e) => {

                console.log("ArticleOnPageNav::items::click")

                this.scrollisjumping = true;
                this.clearActive();
                var ref = decodeURI(e.target.href.substring(e.target.href.lastIndexOf('#') + 1));
                var targetEl = document.getElementById(ref);
                e.target.classList.add("active");
                if (this.width < 768) {
                    this.hScrollTo(e.target, -8);
                    setTimeout(() => {
                        this.vscrollto(targetEl);
                    }, 200);
                } else {
                    setTimeout(() => {
                        this.scrollisjumping = false;
                    }, 400);
                }
                
            })
        })
    }

    isElementInViewport(el) {
        var rect = el.getBoundingClientRect();
        console.log("ArticleOnPageNav:isElementInViewport " + el);

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) * 0.5
            
        );
    }
    hScrollTo(el, hOffest = 0) {
        //el.scrollIntoView({ behavior: 'smooth', inline: 'start' })
        //el.parentNode.scrollLeft = el.offsetLeft - 8;
        console.log("ArticleOnPageNav:hScrollTo " + el);
        el.parentNode.scroll({
            top: 0,
            left: el.offsetLeft + hOffest,
            behavior: 'smooth'
        });
    }
    vscrollto(y) {

        console.log("ArticleOnPageNav:vscrollto " + y);

        var scrollamnt = y.getBoundingClientRect().top + window.scrollY - 100;
        this.scrollDebounce = false;
        window.scrollTo(0, scrollamnt);
        setTimeout(() => {
            this.scrollisjumping = false;
            this.scrollDebounce = true;
        }, 900);
    }

    getAnchor() {
        console.log("ArticleOnPageNav:getAnchor");

        var currentUrl = document.URL,
            urlParts = currentUrl.split('#');

        return (urlParts.length > 1) ? urlParts[1] : null;
    }

    clearActive() {
        console.log("ArticleOnPageNav:clearActive");
        this.items.forEach(item => {
            item.classList.remove("active")
        })
    }

}

customElements.define('article-on-page-nav', ArticleOnPageNav, { extends: 'nav' });